import React from 'react';
import PropTypes from 'prop-types';

const MenuIcon = props => {
  return (
    <svg
      width="16"
      height="12"
      viewBox="0 0 16 12"
      className={props.className || ''}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 5H12V7H0V5ZM0 0H16V2H0V0ZM0 12H7.235V10H0V12Z" />
    </svg>
  );
};

MenuIcon.propTypes = {
  className: PropTypes.string,
};

export default MenuIcon;
